import { render, staticRenderFns } from "./newEvent.vue?vue&type=template&id=171ada38&"
import script from "./newEvent.vue?vue&type=script&lang=js&"
export * from "./newEvent.vue?vue&type=script&lang=js&"
import style0 from "./newEvent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports